import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export enum AiSettingTone {
  friendly = 'friendly',
  professional = 'professional',
  casual = 'casual',
  concise = 'concise',
}

export enum AiSettingGuestAddressing {
  firstName = 'first_name',
  fullName = 'full_name',
  noName = 'no_name',
}

export enum AiSettingIdentity {
  asHost = 'as_host',
  asAssistant = 'as_assistant',
}

export default class AiSettingModel extends Model {
  @attr('string') tone!: AiSettingTone;
  @attr('string') guestAddressing!: AiSettingGuestAddressing;
  @attr('string') identity!: AiSettingIdentity;
  @attr('boolean') autoReplyEnabled?: boolean | null;
  @attr('number') autoReplyDelaySeconds?: number | null;
  @attr('date') createdAt!: Date;
  @attr('date') updatedAt!: Date;

  @belongsTo('property', { inverse: null, async: false })
  property?: ModelRegistry['property'];

  get isPropertyOverride(): boolean {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return !!(this as any).belongsTo('property').id();
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'ai-setting': AiSettingModel;
  }
}
